const error = {
  err_email_password_not_found:
    'The email address or password you entered is not correct.',
  err_google_oauth2_not_found:
    'This account does not exist. Are you signed in to the correct Google account?',
  err_ms_oauth2_not_found:
    'This account does not exist. Are you signed in to the correct Microsoft account?',
  err_otp_required:
    'Too many failed sign-in attempts. Please request an OTP to proceed.',
  err_otp_limit_reached:
    'Too many failed OTP attempts. Please try again later.',
  err_otp_invalid: 'The OTP you entered is not correct.',
  err_user_deleted:
    "You're no longer part of this Kula account. Contact your Kula admin for help",
  err_user_not_found:
    "You're not part of this Kula account. Contact your Kula admin for help",
  err_oauth_access_denied: 'Authentication access denied. Please try again',
  err_terminated:
    'The Kula organisation account has been terminated. Get in touch with support@kula.ai for more details.',
  something_went_wrong: 'Something went wrong. Please try again',
  err_user_seats_limit_reached:
    'All available seats in Kula are taken. Contact your Kula admin for access.',
};

export const getErrorMessage = (err) => {
  //! Clean up needed later, Currently for some issues BE is sending the error code and for something they are using error message, Need to align and change
  const isErrorCodeError = err.includes('_');
  if (isErrorCodeError) return error[err] || error['something_went_wrong'];
  else return err;
};

export const isVerificationRequired = (errors = []) => {
  if (!errors?.length) return false;
  return errors?.some((error) => error === 'err_otp_required');
};

const getErrorCode = (error) => {
  if (error.includes('err_')) return error;
  if (error.includes('password you entered is not correct')) {
    return 'err_email_password_not_found';
  }
  if (error.includes('request an OTP')) {
    return 'err_otp_required';
  }
  if (error.includes('Too many failed OTP attempts')) {
    return 'err_otp_limit_reached';
  }
  if (error.includes('OTP you entered is not correct')) {
    return 'err_otp_invalid';
  }
};

export const getErrorsCode = (errors = []) => {
  return errors?.map((error) => getErrorCode(error));
};
